module.exports = __webpack_public_path__ + "img/3.228dd773.png";